import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicOMLDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismic-omlcontainer',
  templateUrl: './seismic-omlcontainer.component.html',
  styleUrls: ['./seismic-omlcontainer.component.scss'],
})
export class SeismicOMLContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  oilmineralleases$: Observable<SeismicOMLDto[]>;
  loading: boolean;
  isLoadingOilMineralLease$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingOilMineralLease$ = this.gatwayFacade.isLoadingGateway(
      'SeismicOML'
    );
    this.oilmineralleases$ = this.gatwayFacade.loadGateway('SeismicOML');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteOilMineralLease(deletedValue: any) {
    this.gatwayFacade.remove('SeismicOML', deletedValue);
  }

  // this method control both the create and update

  onSubmitOilMineralLease(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.OilMineralLeases;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllOilMineralLease = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllOilMineralLease.push(pullData[i]);
      }
    }

    // check if the addAllOilMineralLease array is not empty, then dispatch the data to the store
    if (addAllOilMineralLease.length > 0) {
      this.gatwayFacade.add('SeismicOML', addAllOilMineralLease);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('SeismicOML', allUpdates, ['id']);
    }
  }
}
